import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { SnMenuItem } from '../../models';
import { SnMenuItemConfig } from '../../types';

@Component({
  selector: 'sn-menu',
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./menu.component.scss'],
})
export class SnMenuComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('items')
  set itemsConfig(value: (SnMenuItemConfig | SnMenuItem)[]) {
    this._items = value.map((item) => {
      return item instanceof SnMenuItem ? item : SnMenuItem.fromConfig(item);
    });
  }

  @Input()
  public context: any;

  private _items: SnMenuItem[] = [];

  constructor() {}

  get items(): SnMenuItem[] {
    return this._items;
  }

  public trackItem(index: number): any {
    return index;
  }
}
